import React from 'react';
import DetailBar from './components/DetailBar';
import { Card, Col, Tabs, Row, Spin, Space } from 'antd';
import DualAxisChart from '../../../../../shared/charts/DualAxisChart';
import { summaryScale } from '../../utils';
import TransactionCreativeDetails from './components/transactionCreatives/TransactionCreativesDetails';
import TransactionPublisherDetails from './components/transactionPublishers/TransactionPublisherDetails';
import TransactionDetails from './components/transactions/TransactionDetails';
import moment from 'moment';

const TransactionsTab = ({
  byDate,
  byDayOfWeek,
  defaultSummaryDates,
  creatives,
  publishers,
  transactions,
  transactionsPagination,
  getImpressions,
  detailBarSummary,
  changeDatePicker,
  changeAttributionWindow,
  attributionWindow,
  attributionMethod,
  changeAttributionMethod,
  campaignOrder,
  // Individual loading states
  byDateLoading,
  creativesLoading,
  publishersLoading,
  transactionsLoading,
  detailsLoading,
  creativesByDateLoading,
  publishersByDateLoading,
}) => {
  const dropDownOptions = [
    { key: 'transactions', display: 'Transactions' },
    { key: 'revenue', display: 'Revenue' },
    { key: 'customers', display: 'Customers' },
    { key: 'spend', display: 'Spend' },
  ];
  return (
    <>
      <DetailBar data={detailBarSummary} loading={detailsLoading || byDateLoading} />
      <Spin spinning={byDateLoading}>
        <Card>
          <Tabs>
            <Tabs.TabPane tab="By Date" key="1">
              <DualAxisChart
                byDate={byDate}
                xAxis="date"
                options={dropDownOptions}
                defaultLeftYValue={dropDownOptions[0]}
                defaultRightYValue={dropDownOptions[1]}
                defaultSummaryDates={defaultSummaryDates}
                customScale={summaryScale}
                onDatePickerChange={({ data, dates, rangeKey }) => {
                  changeDatePicker(dates);
                }}
                has6MonDisables={false}
                allTimeDateRange={[moment(campaignOrder.startDate), moment(campaignOrder.endDate)]}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Day of Week" key="2">
              <DualAxisChart
                byDate={byDayOfWeek}
                xAxis="dayOfWeek"
                options={dropDownOptions}
                defaultLeftYValue={dropDownOptions[0]}
                defaultRightYValue={dropDownOptions[1]}
                customScale={summaryScale}
                has6MonDisables={true}
                showDatePicker={false}
                noDateChart={true}
              />
            </Tabs.TabPane>
          </Tabs>
        </Card>
      </Spin>
      <Row gutter={[35, 35]} style={{ marginTop: '1%' }}>
        <Col span={24}>
          <TransactionCreativeDetails
            creatives={creatives}
            loading={creativesLoading}
            byDateLoading={creativesByDateLoading}
          />
        </Col>
        <Col span={24}>
          <TransactionPublisherDetails
            publishers={publishers}
            loading={publishersLoading}
            byDateLoading={publishersByDateLoading}
          />
        </Col>
        <Col span={24}>
          <TransactionDetails
            transactions={transactions}
            transactionsPagination={transactionsPagination}
            getImpressions={getImpressions}
            loading={transactionsLoading}
            changeAttributionWindow={changeAttributionWindow}
            attributionWindow={attributionWindow}
            changeAttributionMethod={changeAttributionMethod}
            attributionMethod={attributionMethod}
          />
        </Col>
      </Row>
    </>
  );
};

export default TransactionsTab;
